import { toastWarning } from '../toastr'
import { MissingEInvoiceData } from '@/services/InvoiceApi'
import { DocumentItemModel } from '@/shared/models'

type TFunc = (key: string, params?: Record<string, any>) => string

const COMPANY_FIELD_MAP: Record<string, string> = {
    companyOib: 'Allaround.Validation.Fiscalization.missingCompanyTaxID',
    contactEmail: 'Allaround.Validation.Fiscalization.email',
    street: 'Allaround.Validation.Fiscalization.missingCompanyAddress',
    streetNumber: 'Allaround.Validation.Fiscalization.missingCompanyAddressNumber',
    city: 'Allaround.Validation.Fiscalization.missingCompanyCity',
    postalCode: 'Allaround.Validation.Fiscalization.zipCodeNotNumeric',
    country: 'Allaround.Validation.Fiscalization.country',
    userOib: 'Allaround.Validation.Fiscalization.missingPersonalIDs',
    bankAccount: 'Allaround.PaymentType.bankAccount.title',
}

function validateEInvoiceCompanyData(missing: MissingEInvoiceData | null | undefined, t: TFunc): boolean {
    if (!missing) return true

    type MissingKey = keyof MissingEInvoiceData

    const lines: string[] = []

    const baseMissingMessage = t('Allaround.Validation.Fiscalization.eInvoiceSettingsIntroMessage')

    const missingData: string[] = []
    for (const key of Object.keys(missing) as MissingKey[]) {
        if (key === ('invalidVatItemNames' as MissingKey)) continue
        if (!missing[key]) continue

        const mappedKey = COMPANY_FIELD_MAP[String(key)]
        const fieldLabel = mappedKey ? t(mappedKey) : String(key)
        missingData.push(fieldLabel)
    }

    if (missingData.length !== 0) {
        const missingItemsMessage = missingData.join(', ')
        lines.push(`${baseMissingMessage} ${missingItemsMessage}`)
    }

    const invalidVatItemNames = missing.invalidVatItemNames as string[] | undefined
    if (Array.isArray(invalidVatItemNames) && invalidVatItemNames.length > 0) {
        const items = invalidVatItemNames.join(', ')
        const baseMessage = t('Invoice.SendEInvoice.Message.InvalidVatItemNames')
        lines.push(items ? `${baseMessage} ${items}` : baseMessage)
    }

    if (lines.length === 0) return true

    const message = lines.join('\n')
    console.log(message)

    toastWarning(message, true, false)

    return false
}

export function validateEInvoicePreOpenForDocument(
    configuration: { missingEInvoiceData: MissingEInvoiceData },
    doc: { client?: any },
    t: TFunc
): boolean {
    const okCompany = validateEInvoiceCompanyData(configuration?.missingEInvoiceData, t)
    if (!okCompany) return false

    if (!doc.client) {
        toastWarning('Invoice.SendEInvoice.Message.noClient')
        return false
    }

    return true
}

export function validateEInvoicePreOpenForList(
    configuration: { missingEInvoiceData: MissingEInvoiceData },
    row: { clientId?: number | null },
    t: TFunc
): boolean {
    const okCompany = validateEInvoiceCompanyData(configuration?.missingEInvoiceData, t)
    if (!okCompany) return false

    if (!row.clientId) {
        toastWarning('Invoice.SendEInvoice.Message.noClient')
        return false
    }

    return true
}

export function validateEInvoiceItems(items: DocumentItemModel[] | undefined, t: TFunc): boolean {
    if (!items) return true

    let isValid = true
    for (const item of items) {
        const nameLength = item.name ? item.name.length : 0
        const descriptionLength = item.additionalNote ? item.additionalNote.length : 0

        let itemHasError = false
        if (nameLength >= 1024) {
            toastWarning('Invoice.SendEInvoice.Message.ItemNameTooLong', undefined, undefined, {
                name: item.name.substring(0, 50),
            })
            isValid = false
            itemHasError = true
        }
        if (descriptionLength >= 4096) {
            toastWarning('Invoice.SendEInvoice.Message.ItemDescriptionTooLong', undefined, undefined, {
                description: item.additionalNote!.substring(0, 50),
            })
            isValid = false
            itemHasError = true
        }

        if (itemHasError) break
    }

    return isValid
}
